import { styled } from '../jss-style';
import descriptionsStyle from './descriptions';

const useDescriptionsStyle = styled(descriptionsStyle, 'descriptions');
export { descriptionsStyle, useDescriptionsStyle };
export default useDescriptionsStyle;
